// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"07ccd3d0","388":"1e0849db","617":"07ccd3d0","724":"07ccd3d0","756":"66ef4b7a","896":"07ccd3d0","923":"07ccd3d0"}[chunkId] + ".chunk.css";
};